import React from 'react';
import { Components, styles } from './styled';
import { SelectChangeEvent } from '@mui/material/Select/SelectInput';
import { ReactComponent as ClockIcon } from '../../../assets/icons/icon-clock-alt.svg';
import InputAdornment from '@mui/material/InputAdornment';
import { parseMinutesToHourAndMinutes } from '../../../utils/dateFormat';
import { TIME_PICKER_VALUES } from '../constants';
import { ReactComponent as ArrowDownIcon } from '../../../assets/icons/icon-angle-down.svg';

const SelectIcon = () => {
  return (
    <Components.SelectIcon>
      <ArrowDownIcon />
    </Components.SelectIcon>
  );
};

const ProjectTimePicker = ({
  value,
  onValueChange,
  fontSize = 'default',
  hasBorder,
  hasLeftIcon = true,
  disabled = false,
}: {
  value: number | undefined;
  onValueChange?: (value: number) => void;
  fontSize?: 'default' | 'big';
  hasBorder?: boolean;
  hasLeftIcon?: boolean;
  disabled?: boolean;
}) => {
  const _onValueChange = (e: SelectChangeEvent<unknown>) => {
    onValueChange?.(e.target.value as number);
  };

  return (
    <Components.Select
      value={value}
      onChange={_onValueChange}
      {...(hasLeftIcon && {
        startAdornment: (
          <InputAdornment position={'start'}>
            <ClockIcon />
          </InputAdornment>
        ),
      })}
      IconComponent={SelectIcon}
      fontSize={fontSize}
      hasBorder={hasBorder}
      disabled={disabled}
      // @ts-ignore
      MenuProps={{ sx: styles.SelectMenu }}>
      {TIME_PICKER_VALUES.map((item, key) => (
        <Components.MenuItem value={item} key={key}>
          {parseMinutesToHourAndMinutes(item)}
        </Components.MenuItem>
      ))}
    </Components.Select>
  );
};

export default ProjectTimePicker;
